import styles from "./lockcard.module.css";
import { Trash2 } from "react-feather";
import { Checkbox, FormControlLabel } from "@mui/material";
import dayjs from "dayjs";

const LockCard = ({ item, setDeleteModalOpen, setDeleteCardId, setmDeleteCardId, mdeleteCardId }) => {
    console.log(item);
    return <div className={`${styles.NotesCard}`}>
        <div className={`${styles.AlertCardFirstSec}`}>
            <FormControlLabel
                className="CustomCheck"
                control={
                    <Checkbox
                        checked={mdeleteCardId?.indexOf(parseInt(item.id)) > -1}
                        value={item?.id}
                        onChange={(e) => {
                            let selectedTemp = mdeleteCardId;
                            let chkValue = parseInt(e.target.value);
                            if (e.target.checked) {
                                if (selectedTemp.indexOf(chkValue) === -1)
                                    selectedTemp = selectedTemp.concat([chkValue]);
                            } else {
                                selectedTemp = selectedTemp?.filter(i => i !== chkValue);
                            }

                            setmDeleteCardId(selectedTemp);
                        }}
                    />
                }
            />
            <div className={`${styles.DeviceAlertIcon}`}>
                <img src="/static/img/Door.svg" width="30px" height="30px" style={{ marginLeft: '6px' }} alt="" />
            </div>
            <div className={`${styles.AccoTitleHead}`}>
                <div className={`${styles.TextSec}`}>
                    <p className={`${styles.AlertTitle}`}>{item?.lock_name}</p>
                    <p className={`${styles.AlertDateTime}`}>{dayjs(item?.created_at).format('MMMM D, YYYY')} <span>{dayjs(item?.created_at).format('h:mm A')}</span></p>
                </div>
                <button className={`${styles.DeleteLockBU}`} onClick={(e) => { setDeleteModalOpen(true); setDeleteCardId(item?.id); }}><Trash2 /></button>
            </div>
        </div>
    </div>
}

export default LockCard;